import React from 'react';
import { Link } from 'react-router-dom';
import CreateEmailForm from '../../../../Register/Local/CreateEmailForm';
import GoogleButton from '../../../TO/Login/GoogleButton';
import FacebookButton from '../../../TO/Login/FacebookButton';
import AppleButton from '../../../TO/Login/AppleButton';
import pushLinkAnalytics from '../../../../../analytics/pushLinkAnalytics.js';

import AppVars from '../../../../../AppVars.js';
const appVars = AppVars.getInstance();

const COMPONENT_TREE = [
  { component_name: 'RegisterForm', component_version: '1.0.0' },
  { component_name: 'CreateHome', component_version: '1.0.0' }
];

class CreateHomeView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    return (
      <div className="login-wrapper">
        <div className="relative login-box">
          <div
            id="usernameTaken"
            className={`${this.props.isEmailAvailable === false ? "error-modal" : "none"}`}
            role="alert"
            aria-hidden={`${this.props.isEmailAvailable === false ? "false" : "true"}`}
          >
            <div className="error-modal-text">
              <b>{this.props.email}</b> is already registered to an account. <Link to="/" onClick={() => pushLinkAnalytics({ ctaText: 'Sign In', href: '/', tree: COMPONENT_TREE })}>Log in</Link> or try a different email address.
            </div>
            <span onClick={this.props.hideModalUsername} className="modal-close">&times;</span>
          </div>
          <div
            id="responseInvalid"
            className={`${this.props.isResponseValid === false ? "error-modal" : "none"}`}
            role="alert"
            aria-hidden={`${this.props.isResponseValid === false ? "false" : "true"}`}
          >
            <div className="error-modal-text">
              Something went wrong. Please try again.
            </div>
            <span onClick={this.props.hideModalError} className="modal-close">&times;</span>
          </div>
          {/* <div className = "title-padding"></div> */}
          <div className="title__TO left">Create Account</div>
          <Link to={appVars.getAppHomeURL(this.props.style)}><img src={require('../../../../../static/images/Toyota-Logo.svg').default} className="login-logo__TO absolute" alt="Toyota"></img></Link>
          <div className="sign-in-grid">
            <div className="sign-in-subtitle-left sign-in-subtitle">Use your email address</div>
            <div className="sign-in-subtitle-right sign-in-subtitle">Continue with Single Sign-On</div>
            <div className="sign-in-form">
              <CreateEmailForm setResponseValid={this.props.setResponseValid} setEmailAvailable={this.props.setEmailAvailable} displayForm={this.props.displayForm} setEmail={this.props.setEmail} />
              {/* {this.props.payload == null ? <UsernameForm style = "TO" savePayload={this.props.savePayload} /> : null}
          {this.props.payload != null ? <PasswordForm style = "TO" savePayload={this.props.savePayload} payload={this.props.payload} /> : null} */}
            </div>
            <div className="middle-column">
              <div className="vertical-line vertical-top"></div>
              <div className="or">or</div>
              <div className="vertical-line vertical-bottom"></div>
            </div>
            <div className="social-column">
              <div className="sign-in-apple top-social">
                {appVars.getIncludeSignIn("APPLE") === true && <AppleButton />}
              </div>
              <div className="sign-in-google middle-social">
                {appVars.getIncludeSignIn("GOOGLE") === true && <GoogleButton />} <br />
              </div>
              <div className="sign-in-facebook bottom-social">
                {appVars.getIncludeSignIn("FACEBOOK") === true && <FacebookButton />} <br />
              </div>

            </div>
          </div>
        </div>
        <div className="bottom-text">
          <div className="bottom-text-left">You can use your My Lexus or My Toyota <br className="mobile-br" /> or SmartPath account information to log in.</div>
          <br className="mobile-br" />
          <div role="navigation" className="bottom-text-right bottom-text-create">
            <Link className="bottom-link bottom-link-create" to="/" onClick={() => pushLinkAnalytics({ ctaText: 'Sign In Instead', href: '/', tree: COMPONENT_TREE })}>Sign In Instead<img src={require('../../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px" /></Link>
            <br className="mobile-br" />
            <Link className="bottom-link bottom-link-create" to={appVars.getResendActivationEmailURL(this.props.style)} onClick={() => pushLinkAnalytics({ ctaText: 'Activate Account', href: appVars.getResendActivationEmailURL(this.props.style), tree: COMPONENT_TREE })}>Activate Account<img src={require('../../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px" /></Link>
            <br className="mobile-br" />
            <Link className="bottom-link bottom-link-create" to={appVars.getSupportURL(this.props.style)} onClick={() => pushLinkAnalytics({ ctaText: 'Support', href: appVars.getSupportURL(), tree: COMPONENT_TREE })}>Support<img src={require('../../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px" /></Link>
          </div>
        </div>
      </div>
    )
  }
}

export default CreateHomeView;